import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import Company from "../../models/company";

export interface CompanyState {
  loaded: boolean;
  loading: Boolean;
  error: boolean;
  errorDetails: string[];
  data: {
    company: Company;
    userCompanies: Company[];
  };
}

const initialState: CompanyState = {
  loaded: false,
  loading: false,
  error: false,
  errorDetails: [],
  data: {
    company: {},
    userCompanies: [],
  },
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompanyLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setCompanyLoaded: (state, action: PayloadAction<boolean>) => {
      state.loaded = action.payload;
    },
    setCompany: (state, action: PayloadAction<Company>) => {
      state.loaded = true;
      state.loading = false;
      state.data.company = action.payload;
    },
    setCompanyErrorLoading: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
    setUserCompanies: (state, action: PayloadAction<Company[]>) => {
      state.data.userCompanies = action.payload;
    },
  },
});

export const {
  setCompanyLoading,
  setCompanyLoaded,
  setCompany,
  setCompanyErrorLoading,
  setUserCompanies,
} = companySlice.actions;

export default companySlice.reducer;
